<template>
  <v-container class="home px-0">
    <v-row style="width: 90vw; margin: 0 auto;">
      <v-text-field
        placeholder="O que você está procurando?"
        outlined
        color="#FF8723"
        v-model="strPesquisa"
        dense
        @keyup.enter="$router.push('/s/'+strPesquisa)"
      ></v-text-field>
    </v-row>
    <v-row class="mt-0 d-flex align-center" v-for="(i, k) in garrafas" :key="k">
      <v-progress-circular
        indeterminate
        class="mx-auto"
        v-if="loading"
        color="#FF8723"
      ></v-progress-circular>
      <v-col cols="1" class="pt-4">
        <p
          :class="k == 'Destaques' ? 'nomeLeft tagDest' : 'nomeLeft'"
        >
          {{ k }}
        </p>
      </v-col>
      <v-col cols="11" class="pl-5">
        <carousel-garrafas :produtos="i"></carousel-garrafas>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "../css/home.css";
import CarouselGarrafas from "../components/CarouselGarrafas.vue";
export default {
  name: "home",
  components: { CarouselGarrafas },
  data() {
    return {
      strPesquisa:"",
      garrafas: [],
      loading: false,
    };
  },
  created() {
    this.loading = true;
    fetch(this.$drink_uri + "/get-garrafas",
    {headers: {
      'Authorization': `Bearer ${localStorage.tokenDrink}`
    },            credentials: "include"})
      .then((response) => {
        if(response.ok){
          return response.json();
        }
        return Promise.reject(response);
      })
      .then((data) => {
        this.garrafas = data;
        this.$store.commit("set_garrafas", data)
        this.loading = false;
        this.$forceUpdate();
      }).catch(err => { 
        if (err.status === 401) { 
          alert("Login expirado, por favor faça login novamente.")
          this.$router.replace("/login")
        }
      });
  },
};
</script>
